module.exports = __webpack_public_path__ + "img/vk.bac629ec.svg";